var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-dropdown-multiselection.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import "@adornis/forms/x-checkbox.js";
import "@adornis/forms/x-input.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { XDropdownSelection } from "./x-dropdown-selection.js";
var XDropdownMultiSelection = class extends XDropdownSelection {
  constructor() {
    super(...arguments);
    this._allSelected = false;
    this.renderItem = (x, index, value) => html`
    <x-flex ${css({ padding: `${this.spacing.sm} ${this.spacing.md}` })}>
      <x-checkbox
        disabled
        boolean-only
        .value=${this.value.value?.includes(x)}
        label=${this.renderString(x, index)}
      ></x-checkbox>
    </x-flex>
  `;
    this.renderSelected = (x) => x?.map((y) => this.renderString(y)).join(", ") ?? "";
  }
  _choose(selectable) {
    const valueCopy = this.value.value ? [...this.value.value] : [];
    if (valueCopy.includes(selectable)) {
      valueCopy.splice(valueCopy.indexOf(selectable), 1);
    } else {
      valueCopy.push(selectable);
    }
    this.value.next(valueCopy);
  }
  _guardTrigger() {
    return super._guardTrigger().concat([this.renderSelected(this.value.value), this._allSelected]);
  }
  _dropdownContent() {
    return html` ${this._search()} ${this._allSelector()} ${this._items()} `;
  }
  _allSelector() {
    return this["all-selector"] ? html`
          <x-flex ${css({ padding: `${this.spacing.sm} ${this.spacing.md}` })}>
            <x-checkbox
              .value=${this._allSelected}
              label=${this["all-selector"]}
              @value-picked=${(e) => {
      this._allSelected = e.detail.value;
      if (this._allSelected)
        this._selectAll();
      else
        this._clear();
    }}
            ></x-checkbox>
          </x-flex>
        ` : nothing;
  }
  _selectAll() {
    const selectables = this._searchResultSelectables.value ?? [];
    this.value.next([...selectables]);
  }
  _clear() {
    super._clear();
    this._allSelected = false;
  }
};
__decorateClass([
  property()
], XDropdownMultiSelection.prototype, "all-selector", 2);
__decorateClass([
  state()
], XDropdownMultiSelection.prototype, "_allSelected", 2);
XDropdownMultiSelection = __decorateClass([
  customElement("x-dropdown-multiselection")
], XDropdownMultiSelection);
export {
  XDropdownMultiSelection
};
